<template>
    <CadastroPadrao :cabecalho="state.cabecalho" :linhas="state.linhas" :url="state.url" :titulo="state.titulo"
        :limparInput="limparInput" :objeto="state.objetoAuxiliar" :lstObrigatorios="state.lstObrigatorios"
        :lstObrigatoriosLabel="state.lstObrigatoriosLabel">
        <template v-slot:ficha>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Código
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.id" disabled
                        @input="replicarSom()">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Descrição
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.descricao"
                        @input="replicarSom(), replicarLetraCodigo()" placeholder="Descrição">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Ativo
                </label>
                <div class="col inp">
                    <input type="checkbox" class="form-check-input" v-model="state.objetoAuxiliar.ativo">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Urgência
                </label>
                <div class="col inp">
                    <input type="checkbox" class="form-check-input" v-model="state.objetoAuxiliar.urgencia">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Cor
                </label>
                <div class="col inp">
                    <input type="color" class="form-control" v-model="state.objetoAuxiliar.cor">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Cor Ícone
                </label>
                <div class="col inp">
                    <input type="color" class="form-control" v-model="state.objetoAuxiliar.corIcone">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Fonte
                </label>
                <div class="col inp">
                    <input type="color" class="form-control" v-model="state.objetoAuxiliar.fonte">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Borda
                </label>
                <div class="col inp">
                    <input type="color" class="form-control" v-model="state.objetoAuxiliar.borda">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Letra Código
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.codigo">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Depende de
                </label>
                <div class="col inp">
                    <select class="form-select" v-model="state.objetoAuxiliar.id_Principal">
                        <option :value="0">Nenhum</option>
                        <option v-for="(c, index) in tipoChamado" :key="index" :value="c.id">
                            {{ c.descricao }}
                        </option>
                    </select>
                </div>
            </div>
        </template>
    </CadastroPadrao>
</template>

<script setup>
import CadastroPadrao from '@/components/CadastroPadrao.vue';
import store from '@/store/store';
import { reactive, onMounted, computed } from 'vue';

const state = reactive({
    cabecalho: ['Descrição', 'Código', 'Pai', 'Ativo'],
    linhas: ['descricao', 'id', 'id_Principal', 'ativo'],
    url: "TipoChamado",
    titulo: "Cadastro de Tipo Chamado",
    objetoAuxiliar: {
        ativo: Boolean(),
        id_Principal: null,
    },
    lstObrigatorios: ['descricao'],
    lstObrigatoriosLabel: ['Descrição'],
});
function replicarSom() {
    state.objetoAuxiliar.som = String(state.objetoAuxiliar.descricao).toLowerCase();
}
function replicarLetraCodigo() {
    state.objetoAuxiliar.codigo = String(state.objetoAuxiliar.descricao[0]).toUpperCase();
}
async function limparInput(pObj) {
    if (pObj) {
        state.objetoAuxiliar = pObj;
    } else {
        state.objetoAuxiliar = {};
        let maiorId = 0;
        tipoChamado.value.forEach(t => {
            if (maiorId < t.id) {
                maiorId = t.id;
            }
        });
        state.objetoAuxiliar.id = 0;
        state.objetoAuxiliar.ativo = true;
        state.objetoAuxiliar.urgencia = false;
        state.objetoAuxiliar.cor = "#000000";
        state.objetoAuxiliar.fonte = "#000000";
        state.objetoAuxiliar.borda = "#000000";
        state.objetoAuxiliar.corIcone = "#000000";
    }
}
const tipoChamado = computed(() => {
    return store.state.tipoChamado;
});
</script>

<style scoped>
.lbl {
    max-width: 35%;
    line-height: 35px;
}
</style>